var exports = {
  "Nr": "VoiceActivityCard.module__card___bEhjdX",
  "wu": "VoiceActivityCard.module__headerContextGroup___bEhjdX",
  "U1": "VoiceActivityCard.module__headerRow___bEhjdX",
  "LD": "VoiceActivityCard.module__headerLeft___bEhjdX",
  "mB": "VoiceActivityCard.module__activityLabel___bEhjdX",
  "l1": "VoiceActivityCard.module__streamingLabel___bEhjdX",
  "kf": "VoiceActivityCard.module__contextButton___bEhjdX",
  "kx": "VoiceActivityCard.module__contextChannelName___bEhjdX",
  "fd": "VoiceActivityCard.module__contextIcon___bEhjdX",
  "gE": "VoiceActivityCard.module__actionIcon___bEhjdX",
  "o_": "VoiceActivityCard.module__contextGuildIcon___bEhjdX",
  "pz": "VoiceActivityCard.module__contextChevron___bEhjdX",
  "mr": "VoiceActivityCard.module__contextDmAvatar___bEhjdX",
  "Nu": "VoiceActivityCard.module__participantsRow___bEhjdX",
  "i1": "VoiceActivityCard.module__previewContainer___bEhjdX",
  "n": "VoiceActivityCard.module__previewSubmitting___bEhjdX",
  "FC": "VoiceActivityCard.module__previewHoverOverlay___bEhjdX",
  "oz": "VoiceActivityCard.module__previewImage___bEhjdX",
  "nZ": "VoiceActivityCard.module__previewFallback___bEhjdX",
  "Mp": "VoiceActivityCard.module__previewHoverText___bEhjdX",
  "$l": "VoiceActivityCard.module__actionRow___bEhjdX",
  "hP": "VoiceActivityCard.module__actionButton___bEhjdX",
};

module.exports = exports;
